import { BaseService } from './BaseService';
import {
  CreateUpdateHealthInjectorCommand,
  HealthInjectorsQueryResult,
  ReaderActionsQueryResult
} from '../models/device';
import {
  DeviceUploadDeviceFirmwarePayload,
  HealthSystemDomainDeviceResultReadersQueryResult
} from '../api/HealthSystemApi';

export class DeviceService extends BaseService {
  getHelathInjectors = async (
    page: number,
    size: number,
    macAddress?: string,
    farmId?: string
  ): Promise<HealthInjectorsQueryResult> => {
    const query = this.BuildQueryString({ page, size, macAddress, farmId });

    const result = await this.Fetch(`/device/injector?${query}`, 'GET');

    return this.FromResult<HealthInjectorsQueryResult>(result);
  };

  createHelathInjector = async (command: CreateUpdateHealthInjectorCommand): Promise<string> => {
    const result = await this.Fetch('/device/injector', 'POST', JSON.stringify(command));

    return this.FromResult<string>(result);
  };

  updateHelathInjector = async (command: CreateUpdateHealthInjectorCommand): Promise<string> => {
    const result = await this.Fetch('/device/injector', 'PUT', JSON.stringify(command));

    return this.FromResult<string>(result);
  };

  getReaders = async (
    page: number,
    size: number,
    slaughterhouseId?: string,
    macAddress?: string
  ): Promise<HealthSystemDomainDeviceResultReadersQueryResult> => {
    const query = this.BuildQueryString({ page, size, SlaughterhouseId: slaughterhouseId, MacAddress: macAddress });
    const result = await this.Fetch(`/device/reader?${query}`, 'GET');
    return this.FromResult<HealthSystemDomainDeviceResultReadersQueryResult>(result);
  };

  getReaderActions = async (
    page: number,
    size: number,
    from: Date | null,
    to: Date | null,
    calculateReadRate: boolean,
    excludeZeroHooks: boolean,
    excludeZeroNumbers: boolean,
    id?: string,
    number?: string,
    hook?: string,
    farmId?: string
  ): Promise<ReaderActionsQueryResult> => {
    const command = {
      page,
      size,
      calculateReadRate,
      excludeZeroHooks,
      excludeZeroNumbers,
      id,
      from,
      to,
      number,
      hook,
      farmId
    };

    const result = await this.Fetch(`/device/reader/action/search`, 'POST', JSON.stringify(command));

    return this.FromResult<ReaderActionsQueryResult>(result);
  };

  uploadDeviceFirmware = async (fw: DeviceUploadDeviceFirmwarePayload): Promise<string> => {
    if (!fw.Info?.trim() || !fw.Firmware || fw.Firmware.size === 0 || fw.Type === undefined) {
      throw new Error('Upload payload incomplete');
    }

    const formData = new FormData();
    formData.append('Info', fw.Info);
    formData.append('Firmware', fw.Firmware);
    formData.append('Type', fw.Type.toString());

    if (fw.ReleaseNotes?.trim()) {
      formData.append('ReleaseNotes', fw.ReleaseNotes);
    }

    const result = await this.Fetch(`/device/firmware`, 'POST', formData, true, '');

    return this.FromResult<string>(result);
  };
}

export default DeviceService;
